import type {ReactNode} from 'react';
import classNames from 'classnames';

import styles from './attachment-card.module.css';

type Props<Component extends React.ElementType = 'button'> = React.ComponentPropsWithoutRef<Component> & {
    children: ReactNode;
    as?: Component;
};

export const AttachmentCard = ({className, children, as, ...props}: Props) => {
    const ComponentProp: React.ElementType = as ?? 'button';

    return (
        <ComponentProp {...props} className={classNames(styles.card, className)}>
            {children}
        </ComponentProp>
    );
};
